import { render, staticRenderFns } from "./Grow.vue?vue&type=template&id=b2f536b2&"
import script from "./Grow.vue?vue&type=script&lang=js&"
export * from "./Grow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports